import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

import { environment } from '../../../environments/environment';
import { ServicesService } from '../../services/services.service';


@Component({
  selector: 'app-construction-information',
  templateUrl: './construction-information.component.html',
  styleUrls: ['./construction-information.component.css']
})
export class ConstructionInformationComponent implements OnInit {

  fields:any=[];
  listData:any=[];
  constructionData:any=[];
  constructionAnswerData:any=[];
  construction_id;
  projectName:any='';
  lat;
  lng;

  public loading = false;
  isLoader: boolean = false;
  public show:boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  apiUrl = environment.apiUrl;
  apiName = '/get-construction-project-pdf?construction_id=';

  spinLoader = {
    filter : false,
    delete : [],
    pageLoaded: false
  };

  isListData=true;
  isOnePage=false;
  route:string;
  maintenance_id;
  maintainance_user;

  constructor(private activeroute: ActivatedRoute,private _services: ServicesService, private router: Router) {
    this.activeroute.queryParams.subscribe(params => {
      this.construction_id = params['const_id'],
      this.projectName = params['pname'],
      this.maintenance_id =params['maintenance_id']
    });
  }

  async ngOnInit() {
    await this.getPageRequest();
    //console.log("ngonInit", this.construction_id, this.constructionData)
    this.fields = [
      {
        'field' : 'question',
        'title' : 'Question',
        'width' : '30%',
        'code'  : true,
        'sort'  : true
      },
      {
        'field' : 'answer',
        'title' : 'Answer',
        'width' : '25%',
        'code'  : false,
        'sort'  : true
      },
      {
        'field' : 'note',
        'title' : 'Notes ',
        'width' : '25%',
        'code'  : false,
        'sort'  : true
      }
    ]
  }

  resetSearchField(){
    this.searchFields=[''];
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }

  status:any;

  deleteProject(id){
    this.status = confirm("Are You Sure");
    if(this.status){
      this.route = 'delete-project';
      let token = this._services.getToken();
      var data = {
        'id':id,
        page  : this.currentPage,
        search: {
          'const_address' : this.searchFields['const_address'],
        },
        sort  : this.sortingData
      };
      this._services.postRequest(data,this.route,token).subscribe((data: any) => {
        swal({
          title: 'Deleted.',
          text: data.message,
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        }).then(() => {
          this.listData = data.result;
          this.paginate = data.paginate;
          this.getPages(this.paginate.last_page);
        })
      });
    }
  }

  sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
    'field' : '',
    'type'  : ''
  };

  sortBy(field, event){

    this.oldField = (this.oldField != field) ? this.oldField : field;

    if(typeof this.oldField !== 'undefined'){
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
    }

    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
    }

    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
    };

    this.getPageRequest();
  }
  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  searchFields= [];
  pages: any;
//   listData = [];
  editData: Object = {};

  previousPage(){
    if(this.currentPage == 1){
      return;
    }

    this.currentPage = this.currentPage -1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();

  }

  nextPage() {

    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage(){

    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n){
    if(n>1){
      this.isOnePage=true;
    }else{
      this.isOnePage=false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }
  updateContructionData() {
    //console.log("--------", this.constructionData)
  }
  /*------------------------------Pagination Integration Starts Here------------------------*/
  routeData:string;

  async getPageRequest(){
    this.spinLoader['pageLoaded']= true;
    let data;
    if(this.maintenance_id){
      this.routeData = 'get-maintainance-construction-detail-web';
      this.apiName = '/get-maintenance-construction-pdf?construction_id=';
    }
    else{
      this.routeData = 'get-construction-detail-web';
      this.apiName = '/get-construction-project-pdf?construction_id=';
    }
  
    switch(this.routeData){
      case 'get-construction-detail-web':{
        data = {
          page  : this.currentPage,
          construction_id:this.construction_id,
          sort  : this.sortingData
        };
        break;
      }
      case 'get-maintainance-construction-detail-web':{
        data = {
          page  : this.currentPage,
          construction_id:this.construction_id,
          sort  : this.sortingData
        };
        break;
      }
    }

    this.loading = true;
    const token    = localStorage.getItem('userToken');
    this.constructionData = [];
    //console.log("come here?")
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      //console.log("here")
      if(this._services.checkToken('status')){
        this.spinLoader['filter'] = false;
        this.isListData=false;      
        this.constructionAnswerData = [];
        this.constructionData = result.construction.result[0];
        this.updateContructionData()
        //console.log("constructionData", this.constructionData)
        
        if(this.maintenance_id){
          if(typeof result.construction.user_data !== 'undefined' && result.construction.user_data.length > 0){
              //console.log(result.construction.user_data);
              //console.log("first_name : ",result.construction.user_data.first_name);
              this.maintainance_user = "( " + result.construction.user_data[0].first_name + " " + result.construction.user_data[0].last_name + " )";
            }
        }
        this.lat = Number(result.construction.result[0].const_latitude);
        this.lng = Number(result.construction.result[0].const_longitude);
        this.spinLoader['pageLoaded'] = false;
        this.constructionAnswerData = result.construct_answer;
      }
    });
    return true;
  }

  
  imageModalShow(image) {
    let img_name = this.apiBaseUrl + image ;
    // alert(img_name);
    swal({
      title: 'Construction',
      html: '<img src="'+img_name+'" class="img-responsive">',
      // type: 'success',
      showCancelButton: false,
      showConfirmButton: false
      // confirmButtonColor: 'rgb(17, 205, 239)',
      // cancelButtonColor: 'rgb(245, 54, 92)',
      // confirmButtonText: 'Yes'
    });
  }
}
